import gql from 'graphql-tag';

export default gql`
  mutation createOneEventMutation(
    $course: MongoID!
    $student: MongoID
    $studentsGroup: MongoID
    $lesson: MongoID
    $courseCategory: MongoID
    $title: String
    $color: String
    $dateTime: [DateTime]
  ) {
    createOneEventMutation(
      course: $course
      student: $student
      studentsGroup: $studentsGroup
      lesson: $lesson
      courseCategory: $courseCategory
      title: $title
      color: $color
      dateTime: $dateTime
    ) {
      record {
        _id
      }
    }
  }
`;
